import { ICityData } from "./../../../core/models/regions.models";
import { RegionsService } from "./../../../core/services/regions/regions.service";
import { FormControl, FormBuilder } from "@angular/forms";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "[app-city-search]",
  templateUrl: "./city-search.component.html",
  styleUrls: ["./city-search.component.scss"],
})
export class CitySearchComponent implements OnInit {
  keyword: FormControl;
  @Output() emptyList = new EventEmitter();
  @Input() name;
  @Output() onSearch = new EventEmitter();

  filterCityOptions: ICityData = {
    page: 1,
    return_all: 0,
  };

  constructor(private regionsService: RegionsService) {}

  // convenience getter for easy access to form fields

  ngOnInit(): void {
    this.createForm();
  }
  createForm(): void {
    this.keyword = new FormControl("");
  }
  save() {
    // if (this.keyword.value) {
    this.filterCityOptions.keyword = this.keyword.value;
    this.regionsService.getAllCities(this.filterCityOptions).subscribe(
      (res) => {
        if (res) {
          this.onSearch.emit(res.data.data);
          this.emptyList.emit(false);
          if (!res.data.data.length) {
            this.emptyList.emit(true);
            // setTimeout(() => {
            //   this.emptyList = false
            //   this.keyword.reset()
            // }, 1000);
          }
        }
      },
      (err) => {
        this.onSearch.emit("false");
      }
    );
    // } else {
    //   this.onSearch.emit('false')
    // }
  }
}
